import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import TeamPage from "../views/TeamPage.vue";
import PageNotFound from "../views/PageNotFound.vue";
import Projects from "@/views/ProjectsPage.vue";
import Technology from "@/views/TechnologyView.vue";
import CaseStudies from "@/views/CaseStudies.vue";
import SuggestionsSection from "@/views/SuggestionsSection.vue";
import Quote from "@/views/QuotePage.vue";
import QuoteStart from "@/views/QuoteStart.vue";
import QuoteFeatures from "@/views/QuoteFeatures.vue";
import QuoteDate from "@/views/QuoteDate.vue";
import QuoteDesign from "@/views/QuoteDesign.vue";
import QuoteContact from "@/views/QuoteContact.vue";
import QuoteDone from "@/views/QuoteDone.vue";
import WeAreHiring from "@/views/WeAreHiring.vue";
import SkillsCompetenceTest from "@/views/SkillsCompetenceTest.vue";
import ServicesSales from "@/views/ServicesSales.vue";
import ConsultingAndDesign from "@/views/ConsultingAndDesign.vue";
import TailorMadeSoftware from "@/views/TailorMadeSoftware.vue";
import BlogPage from "@/views/BlogPage.vue";
import BlogPostPage from "@/views/BlogPostPage.vue";
import BlogAdminLogin from "@/views/admin/BlogAdminLogin.vue";
import BlogAdmin from "@/views/admin/BlogAdmin.vue";
import BlogAdminForm from "@/views/admin/BlogAdminForm.vue";

import { useDefaultStore } from "@/store";

const isAdminAuthed = () => !!localStorage.getItem("sid");

const routes = [
	{
		path: "/",
		name: "Home",
		component: HomePage,
	},
	{
		path: "/team",
		name: "TeamPage",
		component: TeamPage,
	},
	{
		path: "/projects",
		name: "Projects",
		component: Projects,
	},
	{
		path: "/quote",
		name: "Quote",
		component: Quote,
		children: [
			// {
			// 	path: "start",
			// 	name: "QuoteStart",
			// 	component: QuoteStart,
			// },
			// {
			// 	path: "features",
			// 	name: "QuoteFeatures",
			// 	component: QuoteFeatures,
			// },
			// {
			// 	path: "date",
			// 	name: "QuoteDate",
			// 	component: QuoteDate,
			// },
			// {
			// 	path: "design",
			// 	name: "QuoteDesign",
			// 	component: QuoteDesign,
			// },
			{
				path: "",
				name: "QuoteContact",
				component: QuoteContact,
			},
			{
				path: "done",
				name: "QuoteDone",
				component: QuoteDone,
				beforeEnter: (to, from, next) => {
					if (!useDefaultStore().isFormValid) {
						next({ name: "QuoteContact" });
					} else {
						next();
					}
				},
			},
		],
	},
	{
		path: "/technologies",
		name: "Technology",
		component: Technology,
	},
	// {
	// 	path: "/casestudies",
	// 	name: "Case Studies",
	// 	component: CaseStudies,
	// },
	// {
	// 	path: "/suggestions",
	// 	name: "SuggestionsSection",
	// 	component: SuggestionsSection,
	// },
	{
		path: "/we-are-hiring",
		name: "WeAreHiring",
		component: WeAreHiring,
	},
	{
		path: "/sales-and-entrepreneurial-skills-competence-test",
		name: "SkillsCompetenceTest",
		component: SkillsCompetenceTest,
	},

	{
		path: "/sales",
		name: "Sales",
		component: ServicesSales,
	},
	{
		path: "/services",
		name: "Services",
		component: ServicesSales,
		// children: [
		// 	{
		// 		path: "consulting_and_design",
		// 		name: "ConsultingAndDesign",
		// 		component: ConsultingAndDesign,
		// 	},
		// 	{
		// 		path: "tailor_made_software",
		// 		name: "TailorMadeSoftware",
		// 		component: TailorMadeSoftware,
		// 	},
		// ],
	},
	{
		path: "/services/consulting_and_design",
		name: "ConsultingAndDesign",
		component: ConsultingAndDesign,
	},
	{
		path: "/services/tailor_made_software",
		name: "TailorMadeSoftware",
		component: TailorMadeSoftware,
	},

	{
		path: "/blog",
		name: "Blog",
		component: BlogPage,
	},
	{
		path: "/blog/:link",
		name: "BlogPost",
		component: BlogPostPage,
	},
	{
		path: "/blog-admin-login",
		name: "BlogAdminLogin",
		component: BlogAdminLogin,
	},
	{
		path: "/blog-admin",
		name: "BlogAdmin",
		component: BlogAdmin,
		beforeEnter: (to, from, next) => isAdminAuthed() ? next() : next({ name: "BlogAdminLogin" }),
	},
	{
		path: "/blog-admin/new",
		name: "BlogAdminForm",
		component: BlogAdminForm,
		beforeEnter: (to, from, next) => isAdminAuthed() ? next() : next({ name: "BlogAdminLogin" }),
	},
	{
		path: "/blog-admin/edit/:link",
		name: "BlogAdminFormEdit",
		component: BlogAdminForm,
		beforeEnter: (to, from, next) => isAdminAuthed() ? next() : next({ name: "BlogAdminLogin" }),
	},
	{
		path: "/:pathMatch(.*)*",
		name: "not-found",
		component: PageNotFound,
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	window.scrollTo(0, 0);
	next();
});

// router.afterEach((to, from) => {
// Map routes to Meta Pixel events
// if (to.path === "/") {
// 	fbq("track", "PageView");
// 	fbq("track", "ViewContent");
// } else {
// 	fbq("track", "PageView");
// }
// });

export default router;
